import * as z from "zod";
import { gql } from "graphql-request";
import { Sys, SysFragment } from "../sys";
import { Image, ImageFragment } from "../image";

export const PollOption = z.object({
  id: z.string(),
  title: z.string().nullable().optional(),
  image: z
    .object({
      id: z.string(),
      title: z.string(),
      width: z.number(),
      height: z.number(),
      url: z.string(),
    })
    .nullable()
    .optional(),
});

export const PollOptionsArray = z.array(PollOption).nullish();

export const PollBase = z.object({
  pollTitle: z.string().nullable(),
  pollOptions: PollOptionsArray,
});

export const CarouselEventPollEntry = PollBase.extend({
  __typename: z.literal("CarouselEventPollEntry"),
  sys: Sys,
  entryTitle: z.string().nullable(),
  entryHideTitle: z.boolean().nullable(),
  carouselImage: Image.nullable(),
  carouselImageEn: Image.nullable(),
});

export type CarouselEventPollEntry = z.infer<typeof CarouselEventPollEntry>;

export const CarouselEventPollEntryFragment = gql`
  fragment CarouselEventPollEntryFragment on CarouselEventPollEntry {
    __typename
    sys {
      ...SysFragment
    }

    entryTitle
    entryHideTitle
    pollTitle
    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }

    pollOptions
  }

  ${SysFragment}
  ${ImageFragment}
`;
